import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import MemberService from "../../services/MemberService";
import { useGlobals } from "../../hooks/useGlobals";
import { useTranslation } from "react-i18next";

function GithubCallBackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setAuthMember } = useGlobals();
  const [error, setError] = useState<string | null>(null);
  const [authError, setAuthError] = useState<string | null>(null);
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");

  const handleGithubCallback = async () => {
    if (code) {
      try {
        setError(null);
        const memberService = new MemberService();
        const { accessToken, refreshToken, member } =
          await memberService.githubAuth(code);

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        setAuthMember(member);
        navigate("/");
      } catch (err: any) {
        console.error("GitHub auth error:", err);
        setError(t("github.errors.authFailed"));
        setAuthError(err?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    handleGithubCallback();
  }, [code]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100">
      <div className="flex flex-col items-center gap-6 bg-white rounded-2xl shadow-xl p-12 max-w-md w-full mx-4">
        {/* GitHub Icon with Animation */}
        <div className="relative">
          <div className="absolute inset-0 bg-gray-800 rounded-full blur-lg opacity-20 animate-pulse"></div>
          <svg
            className="w-16 h-16 text-gray-800 relative animate-bounce"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
          </svg>
        </div>
        {/* Text */}
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">
            {t("github.authenticating")}
          </h1>
          <p className="text-gray-600">{t("github.verifying")}</p>
        </div>
        {/* Loading Spinner */}
        <div className="flex items-center justify-center gap-2 mt-4">
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"></div>
          <div
            className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
            style={{ animationDelay: "0.2s" }}
          ></div>
          <div
            className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"
            style={{ animationDelay: "0.4s" }}
          ></div>
        </div>
        {authError}
      </div>
    </div>
  );
}

export default GithubCallBackPage;
